// © Microsoft Corporation. All rights reserved.

import { customElement } from "@microsoft/fast-element";
import { FeedNavigationTemplate as template } from "./FeedNavigation.template";
import { FeedNavigationStyles as styles } from "./FeedNavigation.styles";
import { FeedNavigation as FeedNavigationBase } from "./FeedNavigation";
import { FeedNavigationItem, FeedNavigationData, ContextBehavior, NavigationGroup } from "./Interfaces";

/**
 * Microsoft News feed navigation web component
 */
@customElement({
    name: "msn-feed-nav",
    template,
    styles
})
class FeedNavigation extends FeedNavigationBase { }

export {
    FeedNavigation,
    FeedNavigationItem,
    NavigationGroup,
    FeedNavigationData,
    ContextBehavior
};
